import { MailCheck, Truck } from 'lucide-react';
import { Link } from 'react-router-dom';

// Logistics dropdown items for navigation
export const logisticsItems = [
  {
    path: '/logistics/stojaki-auto-email',
    label: 'Stojaki Auto-Email',
    icon: MailCheck,
    description: 'Zautomatyzowany system e-maili w sprawie stojaków do klientów'
  }
];

const Logistics = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="module-page-title"><Truck aria-hidden="true" /> Logistyka</h2>
        <p>Usługi i zasoby dla działu logistyki</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {logisticsItems.map((item) => {
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className="tile-card module-tile">
              <span className="tile-icon module-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
              <h3 className="tile-title">{item.label}</h3>
              <p className="tile-description">{item.description}</p>
            </Link>;
          })}
        </div>
      </div>
    </div>
  );
};

export default Logistics;
